/* TDT · Logos — filas en movimiento infinito */
if (!customElements.get('tdt-logo-row')) {
  class TdtLogoRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tdt-lg__track');
      this.original = this.querySelector('.tdt-lg__group');
      if (!this.track || !this.original) return;

      this.speed = parseFloat(this.dataset.speed) || 40;
      let t;
      this.onResize = () => {
        clearTimeout(t);
        t = setTimeout(() => this.build(), 200);
      };

      this.build();
      window.addEventListener('resize', this.onResize);
      this.original.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-running', entry.isIntersecting);
        });
        this.observer.observe(this);
      } else {
        this.classList.add('is-running');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    build() {
      this.track.querySelectorAll('.tdt-lg__group[aria-hidden]').forEach((g) => g.remove());

      const groupWidth = this.original.getBoundingClientRect().width;
      if (!groupWidth) return;

      // Copias suficientes para cubrir la pantalla + una extra (bucle sin cortes)
      const copies = Math.max(1, Math.ceil(this.offsetWidth / groupWidth)) + 1;
      for (let i = 1; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }

      this.style.setProperty('--tdt-lg-shift', groupWidth + 'px');
      this.style.setProperty('--tdt-lg-duration', (groupWidth / this.speed).toFixed(2) + 's');

      // Reinicia la animación con las nuevas medidas
      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';
    }
  }

  customElements.define('tdt-logo-row', TdtLogoRow);
}
